import { rankWith, isTimeControl } from '@jsonforms/core';
import type { ControlProps } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { InputControlComponent } from 'src/components/JsonForm/controls/InputControl';
import { useEvent } from 'src/hooks/useEvent';

export const TimeControlComponent = (props: ControlProps) => {
    const showPicker = useEvent((e: React.FocusEvent<HTMLInputElement>) => {
        e.target.showPicker();
    });
    return <InputControlComponent {...props} type="time" onFocus={showPicker} />;
};

export const TimeControlTester = rankWith(
    5, //increase rank as needed
    isTimeControl,
);

export const TimeControl = withJsonFormsControlProps(TimeControlComponent);
